import React, { useState } from "react";
import Sidebar from "./Layout/Sidebar";
import TopBar from "./Layout/TopBar";
import Footer from "./Footer";
import ImpersonationBanner from "./ImpersonationBanner";
import { User } from "../contexts/HotelContext";

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
  user: User | null;
  showBackButton?: boolean;
}

const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({
  children,
  user,
  showBackButton = false,
}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    localStorage.getItem("sidebarCollapsed") === "true"
  );

  const toggleSidebar = () => {
    const newCollapsed = !sidebarCollapsed;
    setSidebarCollapsed(newCollapsed);
    localStorage.setItem("sidebarCollapsed", newCollapsed.toString());
  };

  return (
    <div className="flex flex-col h-full overflow-hidden bg-neutral-50">
      <ImpersonationBanner />

      <div className="flex flex-1 min-h-0">
        {/* Sidebar - full height */}
        <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />

        {/* Main Content Area */}
        <div className="flex flex-col flex-1 overflow-hidden">
          {/* Top Bar */}
          <TopBar
            user={user}
            showBackButton={showBackButton}
            onToggleSidebar={toggleSidebar}
          />

          {/* Main Content with Footer */}
          {/* id + tabIndex: programmatic focus target after the legal consent
              modal closes (SoftModal must never leave focus on <body>). */}
          <main
            id="main-content"
            tabIndex={-1}
            className="flex-1 overflow-x-hidden overflow-y-auto bg-neutral-50 focus:outline-none"
          >
            <div className="p-6">
              <div className="w-full">{children}</div>
              <Footer />
            </div>
          </main>
        </div>
      </div>

      {/* Mobile Sidebar Overlay */}
      {!sidebarCollapsed && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={toggleSidebar}
        />
      )}
    </div>
  );
};

export default AuthenticatedLayout;
